import EnterpriseDataRooms from './EnterpriseDataRooms.component';

export default EnterpriseDataRooms;